import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Notify from "../../../Common/Notify";
import { Input, Select } from "../../../Common/Forms";
import Modal from "../../../Common/Modal";
import Loading from "../../../Pages/Signup/Loading";
import { createOrganization } from "../../../../actions/OrgAction";
import { updateOrganizationName } from "../../../../actions/SessionAction";
import "./OrganizationFormModal.css";

const $ = window.$;

const OrganizationFormModal = ({
  isOpen = false,
  onClose,
  handleCreateNFetch = () => {},
  handleUpdateNFetch = () => {},
  org = {},
}) => {
  const dispatch = useDispatch();

  const [organization, setOrganization] = useState(org);
  const [isLoading, setIsloading] = useState(false);

  const handleOrgUpdate = (e) => {
    setOrganization({
      ...organization,
      [e.target.id]: e.target.value,
    });
  };

  const handleCreateOrganization = () => {
    const corporate = {
      name: organization.name,
      // corporateName: organization.name,
      // business_address1: organization.address1,
      // business_address2: organization.address2,
      // city: organization.city || "",
      // state: organization.state ||  "",
      // country: organization.country || "",
      // postalCode: organization.postalCode,
    };
    setIsloading(true);
    dispatch(createOrganization(corporate))
      .then((res) => {
        if (res.organization) {
          setIsloading(false);
          handleCreateNFetch();
        }
      });
  };

  const handleUpdateOrganizationName = () => {
    setIsloading(true);

    dispatch(updateOrganizationName(organization.name, organization.objectId))
    .then((res) => {
      if (res) {
        setIsloading(false);
        handleUpdateNFetch(organization.name);
      }
    });
  }

  const handleOnClose = () => {
    onClose();
  };

  return (
    <Modal height="modal-small-fix-height" shown={isOpen} onHide={handleOnClose}>
      <ModalHeader />
      <ModalBody>
        <div className="organization-form-header-2">Corporate Name</div>
        <textarea
          id="name"
          className="form-control text-capitalize setting-textarea no-resize"
          placeholder=""
          defaultValue={organization.name}
          onChange={(e) => handleOrgUpdate(e)}
          required
        />
        {/* <div className="organization-form-header-2">Business Address</div>
        <small style={{ marginTop: "10px" }}>Address 1</small>
        <textarea
          id="address1"
          className="form-control setting-textarea"
          placeholder=""
          defaultValue={"" || organization.address1}
          onChange={(e) => handleOrgUpdate(e)}
          required
        />
        <small style={{ marginTop: 5 }}>Address 2</small>
        <textarea
          id="address2"
          className="form-control setting-textarea"
          placeholder=""
          defaultValue={"" || organization.address2}
          onChange={(e) => handleOrgUpdate(e)}
          required
        />
        <div className="row">
          <span className="col organization-form-select">
            <small className="">City</small>
            <Select
              id="city"
              className="form-control"
              value={organization.city || ""}
              onChange={(e) => handleOrgUpdate(e)}
            >
              <option value="">Select city</option>
              {city.map((item) => (
                <option key={item.objectId} value={item.name}>
                  {item.name}
                </option>
              ))}
            </Select>
          </span>
          <span className="col organization-form-select">
            <small className="">State</small>
            <Select
              id="state"
              className="form-control"
              value={organization.state || ""}
              onChange={(e) => handleOrgUpdate(e)}
            >
              <option value="">Select state</option>
              {state.map((item) => (
                <option key={item.objectId} value={item.objectId}>
                  {item.name}
                </option>
              ))}
            </Select>
          </span>
          <span className="col organization-form-select">
            <small className="">Country</small>
            <Select
              id="country"
              className="form-control"
              value={organization.country || ""}
              onChange={(e) => handleOrgUpdate(e)}
            >
              <option value="">Select country</option>
              {country.map((item) => (
                <option key={item.objectId} value={item.objectId}>
                  {item.name}
                </option>
              ))}
            </Select>
          </span>
          <br />
          <span className="w-100"></span>
          <span className="col-4">
            <small className="">Postal Code</small>
            <textarea
              className="form-control"
              placeholder=""
              //onChange={(e) => setText(e.target.value)}
              required
            />
          </span>
        </div> */}
        {isLoading ? (
            <div
              className="form-group ml-auto"
              style={{
                textAlign: "right",
                position: "relative",
                height: "40px"
              }}
            >
              <Loading />
            </div>
          ) : (
          <div style={{ marginTop: 10, textAlign: "right" }}>
            <button
              type="submit"
              title="Edit Medication"
              className="btn btn-primary btn-md"
              style={{ borderRadius: "12px", marginLeft: "auto" }}
              disabled={isLoading}
              onClick={Object.keys(org) ? handleUpdateOrganizationName : handleCreateOrganization}
            >
              {Object.keys(org) ? "Update" : "Save"}
            </button>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

const ModalHeader = () => {
  return (
    <div className="modal-header">
      <h5 className="text-primary mb-0" style={{ fontSize: "1.25rem" }}>
        Organization
      </h5>
      <button
        type="button"
        className="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

const ModalBody = ({ children, style = {} }) => {
  const styles = {
    ...style,
  };

  return (
    <div className="modal-body" style={styles}>
      {children}
    </div>
  );
};

export default OrganizationFormModal;
